import { GridColDef, GridRowsProp } from '@mui/x-data-grid';
import { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../../app-context';
import IGridComponent from '../../../components/grid/i-grid.component';
import TitlePanel from '../../../components/title-panel/title-panel.component';
import { ALL, GET_AMZ_PRODUCT_URL, PAGE_SIZE } from '../../common/constants';
import { formatDate, formatTo0Decimal, formatTo2Decimal, isEmpty, isEmptyArray, isNotEmptyArray } from '../../common/util.services';
import { getInventory, getTotalInventory, saveAttribute, syncFeeSku, exportInvData, getInvAttribute, getRankTrend, setInventoryStatus, getOrderTrendSku } from '../amazon.services';
import IDialogComponent from '../../../components/dialog/i-dialog.component';
import EditCellComponent from '../../costing/detail/edit-cell.component';
import TextComponent from '../../enquiry/enq-product/edit-text.component';
import RankHistoryComponent from '../rank/rank-history.component';
import PriceHistoryComponent from '../price/price-history.component';
import FeeHistoryComponent from '../fee/fee-history.component';
import { Box, Grid, Stack, Tooltip } from '@mui/material';
import IReadOnlyField from '../../../components/text-component/readonly-field/i-readonlyfield.component';
import { Link } from 'react-router-dom';
import { AssessmentOutlined, PlayCircleOutline } from '@mui/icons-material';
import YesNoDialog from '../../../components/message-dialog/yes-no-dialog.component';
import * as XLSX from 'xlsx';
import FileSaver from 'file-saver';
import SearchPanel from '../../../components/search-panel/search-panel.component';
import IDropdown from '../../../components/text-component/dropdown/i-dropdown.component';
import ITextField from '../../../components/text-component/textfield/i-textfield.component';
import ICheckbox from '../../../components/checkbox/i-checkbox.component';
import LineChart from '../order/line-chart.component';
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import BarChart from './bar-chart.component';
import InfoIcon from '@mui/icons-material/Info';
import RankProductComponent from '../rank/rank-product.component';

const AmazonInventory = () => {
  const appContext = useContext(AppContext);
  const rows: GridRowsProp = [];
  const [inventoryData, setInventoryData] = useState(rows);
  const [totalInventoryData, setTotalInventoryData] = useState([]);
  const [cellLabel, setCellLabel] = useState('');
  const [cellValueRow, setCellValueRow] = useState<any>([]);
  const [rankData, setRankData] = useState<any>([]);
  const [openValue, setOpenValue] = useState(false);
  const [openCellValue, setOpenCellValue] = useState(false);
  const [showMsg, setShowMsg] = useState(false);
  const [message, setMessage] = useState('');
  const [field, setField] = useState('');
  const [sku, setSku] = useState();
  const [openChart, setOpenChart] = useState(false);
  const [orderData, setOrderData] = useState([]);
  const [attribute, setAttribute] = useState('');
  const [attributeValue, setAttributeValue] = useState('');
  const [product, setProduct] = useState(ALL);
  const [color, setColor] = useState(ALL);
  const [size, setSize] = useState(ALL);
  const [pack, setPack] = useState(ALL);
  const [searchText, setSearchText] = useState('');
  const [noPrice, setNoPrice] = useState(true);
  const [inactive, setInactive] = useState(false);
  const [colorList, setColorList] = useState();
  const [sizeList, setSizeList] = useState();
  const [packList, setPackList] = useState();
  const [unitCount, setUnitCount] = useState();
  const [openRank, setOpenRank] = useState(false);
  const [openRankValue, setOpenRankValue] = useState(false);
  const [openRankTrend, setOpenRankTrend] = useState(false);
  const [openPrice, setOpenPrice] = useState(false);
  const [openFee, setOpenFee] = useState(false);
  const popperProps = {sx: {'.MuiTooltip-tooltip': {bgcolor: 'ivory', fontSize: 16, color: 'black', border: 1}}};
  const columns: GridColDef[] = [
    { field: 'product', headerName: 'Product', filterable: false, sortable: false, editable: false, width: 150,
      cellClassName: (params) => { return 'CostingPrd'}
    },
    { field: 'image', headerName: 'Pic', filterable: false, sortable: false, editable: false, width: 50,
      renderCell: (params) => (<Box component="img" src={params.row.image} sx={{ height: 25, width: 25, objectFit: 'cover' }}/>)
    },
    { field: 'sku', headerName: 'SKU', filterable: false, sortable: false, editable: false, width: 70,
      renderCell: (params) => { return (<Link to={'https://www.amazon.com/dp/' + params.row.asin} target="_blank">{params.row.sku}</Link>)}},
    { field: 'color', headerName: 'Color', filterable: false, sortable: false, editable: false, width: 85  },
    { field: 'size', headerName: 'Size', filterable: false, sortable: false, editable: false, width: 80  },
    { field: 'rank', headerName: 'Rank', filterable: false, sortable: false, editable: false, width: 55,
      renderCell: (params) => { return <div className={isEmpty(params.row.rank) ? "" : "cell-link"}
      onClick={() => { openRankTrendPage(params.row.sku) }}>{isEmpty(params.row.rank) ? 'NA' : params.row.rank}</div> }
    },
    { field: 'unitCount', headerName: 'Pack', filterable: false, sortable: false, editable: false, width: 50  },
    { field: 'price', headerName: 'Price', filterable: false, sortable: false, editable: false, width: 65,
      renderCell: (params) => { return <div className={isEmpty(params.row.price) ? "" : "cell-link"}
      onClick={() => { openPricePage(params.row.sku) }}>{isEmpty(params.row.price) ? 'NA' : formatTo2Decimal(params.row.price)}</div> }
    },
    { field: 'amzFee', headerName: 'Fee', filterable: false, sortable: false, editable: false, width: 60,
      renderCell: (params) => { return <div className={isEmpty(params.row.fulfillmentFee) ? "" : "cell-link"}
      onClick={() => { openFeePage(params.row.sku) }}>{isEmpty(params.row.fulfillmentFee) ? 'NA' : 
                                                        formatTo2Decimal(+params.row.fulfillmentFee + +params.row.referralFee)}</div> }
    },
    { field: 'fulfillableQty', headerName: 'Fulfill', filterable: false, sortable: false, editable: false, width: 55,
      cellClassName: (params) => { return params.row.fulfillableQty <= 0 ? 'PerfNegative' : ''}
    },
    { field: 'totalQty', headerName: 'FBA', filterable: false, sortable: false, editable: false, width: 50,
      renderCell: (params: any) =>  (<Tooltip title={getTooltip(params.row)}
      PopperProps={popperProps}>{<Box>{formatTo0Decimal(params.row.totalQty)}</Box>}</Tooltip>)
    },
    { field: 'awdOnhandQty', headerName: 'AWD', filterable: false, sortable: false, editable: false, width: 50,
      renderCell: (params) => {return isEmpty(params.row.awdOnhandQty) ? 0 : formatTo0Decimal(params.row.awdOnhandQty)}
    },
    { field: 'awdInboundQty', headerName: 'AWD-In', filterable: false, sortable: false, editable: false, width: 70,
      renderCell: (params) => {return isEmpty(params.row.awdInboundQty) ? 0 : formatTo0Decimal(params.row.awdInboundQty)}
    },
    { field: 'total', headerName: 'Total', filterable: false, sortable: false, editable: false, width: 50,
      renderCell: (params) => {return params.row.totalQty + params.row.awdOnhandQty + params.row.awdInboundQty},
    },
    { field: 'prevSale', headerName: '150-D Ord', filterable: false, sortable: false, editable: false, width: 85,
      renderCell: (params) => (<Stack direction="row" alignItems="center" gap={1}>
                               <AssessmentOutlined fontSize='small' color="primary"/>{params.row.prevSale}</Stack>)
    },
    { field: 'shipUnit', headerName: 'Top-M Ord', filterable: false, sortable: false, editable: false, width: 90,
      renderCell: (params) => {return isEmpty(params.row.shipUnit) ? 0 : formatTo0Decimal(params.row.shipUnit)}
    },
    { field: 'shipInv', headerName: '150-D Inv', filterable: false, sortable: false, editable: false, width: 80,
      cellClassName: (params) => { return calculateShipUnit(params.row) > 0 ? 'PrdSaleNegative' : ''},
      renderCell: (params) => {return formatTo0Decimal(calculateShipUnit(params.row))}
    },
    { field: 'daysOfSupply', headerName: 'Inv Days', filterable: false, sortable: false, editable: false, width: 75,
      cellClassName: (params) => { return params.row.daysOfSupply < 150 && 0 !== params.row.prevSale ? 'PrdSaleNegative' : ''},
      renderCell: (params) => {return 0 === params.row.prevSale ? 'NA' : formatTo0Decimal(params.row.daysOfSupply)},
    },
    { field: 'dimension', headerName: 'Product Packaging', filterable: false, sortable: false, editable: false, width: 180,
      renderCell: (params: any) =>  (<Tooltip title={getDimensionTooltip(params.row)}
      PopperProps={popperProps}>{<Box>{getDimensionValue(params.row)}</Box>}</Tooltip>)
    },
    { field: 'syncFee', headerName: 'Fee', filterable: false, sortable: false, editable: false, width: 50,
      renderCell: (params) => (<Stack direction="row" alignItems="center" justifyContent="center" sx={{ height: '100%' }} > 
                                <PlayCircleOutline fontSize='small' color="secondary"/></Stack>)
    },
    { 
      field: 'isActive', headerName: 'Active', filterable: false, sortable: false, editable: false, width: 60,
      renderCell: (params) => { return <Stack direction="row" alignItems="center" justifyContent="center" sx={{ height: '100%' }} > 
                                        {1 === params.row.isActive || isEmpty(params.row.isActive) ?
                                        (<CheckCircleOutlinedIcon fontSize='small' color="success"/>) :
                                        (<CancelOutlinedIcon fontSize='small' color="error"/>)}
                                       </Stack>}
    }
  ];
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(PAGE_SIZE);
  const [totalRows, setTotalRows] = useState(0);

  useEffect(() => {
    getInventoryData(page);
    getTotalInventoryData();
  }, [product, color, size, pack, noPrice, page, pageSize]);

  function getInventoryData(page: any) {
    if (isEmptyArray(rows)) {
      setLoading(true);
      let searchData = {product: product, color: color, size: size, pack: pack, noPrice: noPrice, searchText: searchText, inactive: inactive};
      getInventory(searchData, page, pageSize, appContext,
        (response: any) => {
          setInventoryData(response.data.content);
          setTotalRows(response.data.totalElements);
          appContext.setShowLoader(false);
          setLoading(false);
        }, (error: any) => {
          console.log(error);
          appContext.setShowLoader(false);
          appContext.setErrorMessage(error.message);
          setLoading(false);
        });
    }
  };

  function getTotalInventoryData() {
    setLoading(true);
    let searchData = {product: product, color: color, size: size, pack: pack, noPrice: noPrice, searchText: searchText, inactive: inactive};
    getTotalInventory(searchData, appContext,
      (response: any) => {
        setTotalInventoryData(response.data);
        appContext.setShowLoader(false);
        setLoading(false);
      }, (error: any) => {
        console.log(error);
        appContext.setShowLoader(false);
        appContext.setErrorMessage(error.message);
        setLoading(false);
      });
  };

  function calculateShipUnit(row: any) {
    let totalQty = row.totalQty + row.awdOnhandQty + row.awdInboundQty;
    let shipUnit = row.prevSale - totalQty;
    if(shipUnit <= 0) {
      return 0;
    } else {
      return shipUnit;
    }
  }

  function getDimensionValue(row: any) {
    let length = isEmpty(row.skuLength) ? 0 : row.skuLength;
    let width = isEmpty(row.skuWidth) ? 0 : row.skuWidth;
    let height = isEmpty(row.skuHeight) ? 0 : row.skuHeight;
    let weight = isEmpty(row.skuWeight) ? 0 : row.skuWeight;
    return length + 'x' + width + 'x' + height + ' | ' + formatTo2Decimal(weight) + ' Kg';
  }

  function getDimensionTooltip (row: any) {
    let length = isEmpty(row.cartonLength) ? 0 : row.cartonLength;
    let width = isEmpty(row.cartonWidth) ? 0 : row.cartonWidth;
    let height = isEmpty(row.cartonHeight) ? 0 : row.cartonHeight;
    let weight = isEmpty(row.cartonWeight) ? 0 : row.cartonWeight;
    let qtyPerCarton = isEmpty(row.qtyPerCarton) ? 0 : row.qtyPerCarton;

    let text = length + 'x' + width + 'x' + height + ',' + formatTo2Decimal(weight) + ' Kg,' + qtyPerCarton;
    let array = text.split(',');
    array[0] = 'Carton Dimension: ' + array[0];
    array[1] = 'Carton Weight: ' + array[1];
    array[2] = 'Quantity/Carton: ' + array[2];

    let newText = array.map(i => {
      return <p>{i}</p>
    });

    return newText;
  }

  function getTooltip (row: any) {
    let fulfillableQty = row.fulfillableQty;
    let inboundWorkingQty = row.inboundWorkingQty;
    let inboundShippedQty = row.inboundShippedQty;
    let inboundReceivingQty = row.inboundReceivingQty;
    let reservedQty = row.reservedQty;
    let pendingQty = row.pendingQty;

    let text = fulfillableQty + ',' + inboundWorkingQty + ',' + inboundShippedQty + ',' + inboundReceivingQty + ',' + reservedQty + ',' + pendingQty;
    let array = text.split(',');
    array[0] = 'Fulfillable: ' + formatTo0Decimal(array[0]);
    array[1] = 'Inbound Working: ' + formatTo0Decimal(array[1]);
    array[2] = 'Inbound Shipped: ' + formatTo0Decimal(array[2]);
    array[3] = 'Inbound Receiving: ' + formatTo0Decimal(array[3]);
    array[4] = 'Reserved: ' + formatTo0Decimal(array[4]);
    array[5] = 'Pending Order: ' + formatTo0Decimal(array[5]);

    let newText = array.map(i => {
      return <p>{i}</p>
    });

    return newText;
  }

  const onPaginationModelChange = (evt: any) => {
    setPage(evt.page);
    setPageSize(evt.pageSize);
  }
  
  const search = (data: any) => {
    getInventoryData(0);
    getTotalInventoryData();
  }

  /*const openRankPage = (value: any) => {
    setSku(value);
    setOpenRank(true);
  }*/

  const openRankTrendPage = (value: any) => {
    setLoading(true);
    getRankTrend(value, appContext,
      (response: any) => {
        setRankData(response.data);
        appContext.setShowLoader(false);
        setLoading(false);
        setOpenRankTrend(true);
      }, (error: any) => {
        console.log(error);
        appContext.setShowLoader(false);
        appContext.setErrorMessage(error.message);
        setLoading(false);
      });
  }

  const openPricePage = (value: any) => {
    setSku(value);
    setOpenPrice(true);
  }

  const openFeePage = (value: any) => {
    setSku(value);
    setOpenFee(true);
  }

  const closeRankPage = (value: any) => {
    setOpenRank(false);
  }

  const closeRankTrend = (value: any) => {
    setOpenRankTrend(false);
  }
  
  const closePricePage = (value: any) => {
    setOpenPrice(false);
  }

  const closeFeePage = (value: any) => {
    setOpenFee(false);
  }

  const openValuePopup = () => {
    setOpenValue(true);
  }

  const closeValuePopup = () => {
    if(unitCount !== cellValueRow.unitCount) {
      let data = {attribute: 'Unit Count', sku: cellValueRow.sku, unitCount: cellValueRow.unitCount};
      saveAttributeValue(data);
    }
    setOpenValue(false);
  }

  const openCellValuePopup = () => {
    setOpenCellValue(true);
  }

  const openRankPopup = () => {
    setOpenRankValue(true);
  }

  const closeRankPopup = () => {
    setOpenRankValue(false);
  }

  function saveAttributeValue(data: any) {
    setLoading(true);
    appContext.setShowLoader(true);
    saveAttribute(data, appContext,
      (response: any) => {
        appContext.setSuccessMessage(response.message)
        appContext.setShowLoader(false);
        setLoading(false);
      }, (error: any) => {
        appContext.setShowLoader(false);
        appContext.setErrorMessage(error.message)
        setLoading(false);
    });
  }

  const closeCellValuePopup = () => {
    if('Product' === attribute && attributeValue !== cellValueRow.product) {
      let data = {attribute: 'Product', sku: cellValueRow.sku, product: cellValueRow.product};
      saveAttributeValue(data);
    } else if('Color' === attribute && attributeValue !== cellValueRow.color) {
      let data = {attribute: 'Color', sku: cellValueRow.sku, color: cellValueRow.color};
      saveAttributeValue(data);
    } else if('Size' === attribute && attributeValue !== cellValueRow.size) {
      let data = {attribute: 'Size', sku: cellValueRow.sku, size: cellValueRow.size};
      saveAttributeValue(data);
    }
    setOpenCellValue(false);
  }

  const handleCellDoubleClick = (value: any) => {
    const field = value.field;
    if('product' === field) {
      setAttribute('Product');
      setAttributeValue(value.row.product);
      setCellValueRow(value.row);
      setCellLabel('Product');
      openCellValuePopup();
    } else if('color' === field) {
      setAttribute('Color');
      setAttributeValue(value.row.color);
      setCellValueRow(value.row);
      setCellLabel('Color');
      openCellValuePopup();
    } else if('size' === field) {
      setAttribute('Size');
      setAttributeValue(value.row.size);
      setCellValueRow(value.row);
      setCellLabel('Size');
      openCellValuePopup();
    } else if('unitCount' === field) {
      setUnitCount(value.row.unitCount);
      setCellValueRow(value.row);
      setCellLabel('Unit Count');
      openValuePopup();
    }
  }

  const onCellClick = (value: any) => {
    const field = value.field;
    setCellValueRow(value.row);
    setField(field);
    if('syncFee' === field) {
      if(isEmpty(value.row.price) || +value.row.price <= 0 ) {
        appContext.setDialogMessage('Price is not available. Set price first.');
      } else {
        setMessage('Do you want to sync the fee data?');
        setShowMsg(true);
      }
    } else if('isActive' === field) {
      setMessage('Do you want to change the active status?');
      setShowMsg(true);
    } else if('prevSale' === field) {
      openOrderChart(value.row.sku);
    }
  }

  const closeChart = (value: any) => {
    setOpenChart(false);
  }

  const openOrderChart = (sku: any) => {
    setLoading(true);
    getOrderTrendSku(sku, appContext,
      (response: any) => {
        setOrderData(response.data);
        appContext.setShowLoader(false);
        setLoading(false);
        setOpenChart(true);
      }, (error: any) => {
        console.log(error);
        appContext.setShowLoader(false);
        appContext.setErrorMessage(error.message);
        setLoading(false);
      });
  }

  const onOkClick = () => {
    if('syncFee' === field) {
      syncFeeData();
    } else if('isActive' === field) {
      setInvStatus();
    }
  }

  const setInvStatus = () => {
    setLoading(true);
    setInventoryStatus(cellValueRow, appContext,
      (response: any) => {
        appContext.setShowLoader(false);
        appContext.setSuccessMessage(response.message)
        setLoading(false);
        getInventoryData(page);
      }, (error: any) => {
        console.log(error);
        appContext.setShowLoader(false);
        appContext.setErrorMessage(error.message);
        setLoading(false);
      });
  }

  const syncFeeData = () => {
    setLoading(true);
    syncFeeSku(cellValueRow, appContext,
      (response: any) => {
        appContext.setShowLoader(false);
        appContext.setSuccessMessage(response.message)
        setLoading(false);
        getInventoryData(page);
      }, (error: any) => {
        console.log(error);
        appContext.setShowLoader(false);
        appContext.setErrorMessage(error.message);
        setLoading(false);
      });
  }

  const updateAttributeList = (invProduct: any) => {
    setLoading(true);
    getInvAttribute(invProduct, appContext,
      (response: any) => {
        setColorList(response.data[0]);
        setSizeList(response.data[1]);
        setPackList(response.data[2]);
        appContext.setShowLoader(false);
        appContext.setSuccessMessage(response.message)
        setLoading(false);
      }, (error: any) => {
        console.log(error);
        appContext.setShowLoader(false);
        appContext.setErrorMessage(error.message);
        setLoading(false);
      });
  }

  function getInvData(index: any) {
    let invData = totalInventoryData;
    if(isEmptyArray(invData)) {
      return 'NA'
    } else {
      if(15 === index) {
        return formatTo0Decimal(invData[13]);
      } else if(9 === index) {
        return formatTo0Decimal(+invData[7] + +invData[8]);
      } else if(10 === index) {
        return formatTo0Decimal(+invData[6] + +invData[7] + +invData[8]);
      } else if(11 === index) {
        return formatTo0Decimal(+invData[9]);
      } else if(12 === index) {
        return formatTo0Decimal(+invData[10]);
      } else if(13 === index) {
        return formatTo0Decimal(invData[11]);
      } else if(14 === index) {
        return formatTo0Decimal(invData[12]);
      } else {
        return formatTo0Decimal(invData[index]);
      }
    }
  }

  const exportData = () => {
    exportInvData(appContext,
      (response: any) => {
        saveExcel(response.data);
        setLoading(false);
      }, (error: any) => {
        console.log(error);
        setLoading(false);
      });
  }

  const saveExcel = (invData: any) => {
    let header = ["ASIN", "SKU", "FNSKU", "Product", "Color", "Size", "Pack", "Price", "Fulfillment Fee", "Referral Fee", 
                  "Fulfillable", "Inbound Working", "Inbound Shipped", "Inbound Receiving","Reserved", "Pending",
                  "Total FBA", "AWD Inbound", "AWD Onhand", "Total AWD", "FBA + AWD", "150-D Ord", "Top-M Ord", "150-D Inv", "Supply Days"];
    const excelSheet = XLSX.utils.book_new();
    XLSX.utils.sheet_add_aoa(excelSheet, [header]);
    XLSX.utils.sheet_add_json(excelSheet, invData, { origin: 'A2', skipHeader: true });
    const excelBook = { Sheets: { 'Inventory': excelSheet }, SheetNames: ['Inventory'] };
    const excelBuffer = XLSX.write(excelBook, { bookType: 'xlsx', type: 'array', cellStyles:true });
    const excelData = new Blob([excelBuffer], { type: 'xlsx' });
    FileSaver.saveAs(excelData, "Amazon_Inventory.xlsx");
  }

  const getSearchComponent = () => {
    return <SearchPanel search={search} showExportBtn={true} export={exportData}>
      <Grid container spacing={1} alignItems="center">
        <Grid xs={2}>
          <IDropdown name='product' label='Product' url={GET_AMZ_PRODUCT_URL} allItemRequired={true}
            onChangeEvent={(e: any) => {setProduct(e.target.value); setColor(ALL); setSize(ALL); 
                                        setPack(ALL); updateAttributeList(e.target.value); setPage(0);}} />
        </Grid>
        <Grid xs={2}>
          <IDropdown name='color' label='Color' itemList={colorList} allItemRequired={true}
            onChangeEvent={(e: any) => {setColor(e.target.value); setPage(0);}} />
        </Grid>
        <Grid xs={2}>
          <IDropdown name='size' label='Size' itemList={sizeList} allItemRequired={true}
            onChangeEvent={(e: any) => {setSize(e.target.value); setPage(0);}}/>
        </Grid>
        <Grid xs={2}>
          <IDropdown name='pack' label='Pack' itemList={packList} allItemRequired={true}
            onChangeEvent={(e: any) => {setPack(e.target.value); setPage(0);}}/>
        </Grid>
        <Grid xs={2}>
          <ITextField name='searchText' label='Search Text' 
            onActionEvent={(e: any) => {setSearchText(e.target.value)}}/>
        </Grid>
        <Grid xs={1}>
          <ICheckbox name='noPrice' label='No Price' defaultChecked={true} 
            onChangeEvent={(e: any) => {setNoPrice(e.target.checked); setPage(0);}}/>
        </Grid>
        <Grid xs={1}>
          <ICheckbox name='inActive' label='Inactive' defaultChecked={false} 
            onChangeEvent={(e: any) => {setInactive(e.target.checked); setPage(0);}}/>
        </Grid>
      </Grid>
    </SearchPanel>
  }

  const getMainPanel = () => {
    return <>
      {getSearchComponent()}
      <Grid xs={12} display="flex" justifyContent="center">
        <Grid container columnSpacing={1} rowSpacing={0} sx={{ maxWidth: '1380px', mt: 2, border: '1px solid #D3D3D3', borderRadius: '4px', p: 2}}>
          <Grid xs={2.4}>
            <IReadOnlyField label='Latest Inv' value={isNotEmptyArray(inventoryData) ? formatDate(inventoryData[0].latestUpdate) : 'NA'}/>
          </Grid>
          <Grid xs={2.4}>
            <IReadOnlyField label='Latest Fee' value={isNotEmptyArray(inventoryData) ? formatDate(inventoryData[0].latestFee) : 'NA'}/>
          </Grid>
          <Grid xs={2.4}>
            <IReadOnlyField label='Latest Price' value={isNotEmptyArray(inventoryData) ? formatDate(inventoryData[0].latestPrice) : 'NA'}/>
          </Grid>
          <Grid xs={2.4}>
            <IReadOnlyField label='Latest Rank' icon={InfoIcon} onIconClick={() => openRankPopup()}
              value={isNotEmptyArray(inventoryData) ? formatDate(inventoryData[0].latestRank) : 'NA'}/>
          </Grid>
          <Grid xs={2.4}>
            <IReadOnlyField label='Fulfillable' value={getInvData(0)}/>
          </Grid>
          <Grid xs={2.4}>
            <IReadOnlyField label='Inbound Receiving' value={getInvData(1)}/>
          </Grid>
          <Grid xs={2.4}>
            <IReadOnlyField label='Inbound Shipped' value={getInvData(2)}/>
          </Grid>
          <Grid xs={2.4}>
            <IReadOnlyField label='Inbound Working' value={getInvData(3)}/>
          </Grid>
          <Grid xs={2.4}>
            <IReadOnlyField label='Pending Order' value={getInvData(4)}/>
          </Grid>
          <Grid xs={2.4}>
            <IReadOnlyField label='Reserved' value={getInvData(5)}/>
          </Grid>
          <Grid xs={2.4}>
            <IReadOnlyField label='Total FBA' value={getInvData(6)}/>
          </Grid>
          <Grid xs={2.4}>
            <IReadOnlyField label='AWD Onhand' value={getInvData(7)}/>
          </Grid>
          <Grid xs={2.4}>
            <IReadOnlyField label='AWD Inbound' value={getInvData(8)}/>
          </Grid>
          <Grid xs={2.4}>
            <IReadOnlyField label='Total AWD' value={getInvData(9)}/>
          </Grid>
          <Grid xs={2.4}>
            <IReadOnlyField label='FBA + AWD' value={getInvData(10)}/>
          </Grid>
          <Grid xs={2.4}>
            <IReadOnlyField label='150-D Order' value={getInvData(11)}/>
          </Grid>
          <Grid xs={2.4}>
            <IReadOnlyField label='150-D Inv' value={getInvData(15)}/>
          </Grid>
          <Grid xs={2.4}>
            <IReadOnlyField label='Inv Days' value={getInvData(12)}/>
          </Grid>
          <Grid xs={2.4}>
            <IReadOnlyField label='LFH Cost' value={getInvData(13)}/>
          </Grid>
          <Grid xs={2.4}>
            <IReadOnlyField label='Price' value={getInvData(14)}/>
          </Grid>
        </Grid>
      </Grid>
      <IGridComponent title={''} rows={inventoryData} columns={columns} loading={loading} cellDoubleClick={handleCellDoubleClick}
        paginationType="server" paginationModelChange={onPaginationModelChange} totalRows={totalRows} cellClick={onCellClick}
        showAction={false} showApproveAction={false} showDeleteAction={false} showAddBtn={false} 
        getRowId={(row: any) => row.rowId} showExtBtn={false} extBtnText={'Export'} extBtnAction={exportData} maxHeight={380}/>
      <IDialogComponent onClose={closeValuePopup} open={openValue} title={'Specify Unit Count'}
        dialogBody={<EditCellComponent data={cellValueRow} close={closeValuePopup} label={cellLabel}/>} />
      <IDialogComponent onClose={closeCellValuePopup} open={openCellValue} title={'Specify Value'}
        dialogBody={<TextComponent data={cellValueRow} close={closeCellValuePopup} label={cellLabel}/>} />
      <IDialogComponent onClose={closeRankPage} open={openRank} title={'Rank History'}
        dialogBody={<RankHistoryComponent sku={sku}/>} />
      <IDialogComponent onClose={closeRankTrend} open={openRankTrend} title={'Rank Trend'}
        dialogBody={<LineChart data1={rankData}/>} />
      <IDialogComponent onClose={closePricePage} open={openPrice} title={'Price History'}
        dialogBody={<PriceHistoryComponent sku={sku}/>} />
      <IDialogComponent onClose={closeFeePage} open={openFee} title={'Fee History'}
        dialogBody={<FeeHistoryComponent sku={sku}/>} />
      <YesNoDialog open={showMsg} onClose={() => { setShowMsg(false) }}
        onOk={() => { setShowMsg(false); onOkClick(); }} isHorizontal={true} message={message}/>
      <IDialogComponent onClose={closeChart} open={openChart} title={'12-Month Order'}
        dialogBody={<BarChart data={orderData} />} />
      <IDialogComponent onClose={closeRankPopup} open={openRankValue} title={'Product Rank'}
        dialogBody={<RankProductComponent />} />
    </>
  }

  return <TitlePanel title='Inventory' panelBody={getMainPanel()} />
}

export default AmazonInventory;